<div
  class="m-12 sm:mt-16 lg:mt-20 bg-surface border-2 border-border relative overflow-hidden rounded-2xl sm:rounded-3xl p-8 sm:p-12 lg:p-16 text-center group"
>
  <!-- Background Decorations -->
  <div class="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-700">
    <div
      class="absolute top-0 right-0 w-48 h-48 sm:w-64 sm:h-64 bg-primary-soft rounded-full blur-[100px]"
    ></div>
    <div
      class="absolute bottom-0 left-0 w-48 h-48 sm:w-64 sm:h-64 bg-primary-deep rounded-full blur-[100px]"
    ></div>
  </div>

  <div class="relative z-10">
    <!-- Icon -->
    <div
      class="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-primary to-primary-deep rounded-2xl flex items-center justify-center mx-auto mb-6 sm:mb-8 shadow-primary-glow transform hover:scale-105 transition-transform duration-300"
    >
      <i class="fa-solid fa-building text-white text-3xl sm:text-4xl" aria-hidden="true"></i>
    </div>

    <!-- Title -->
    <h2 class="h2 mb-4">
      <span class="text-text-primary">{{ 'projects.developer.title' | translate }}</span>
    </h2>

    <!-- Description -->
    <p
      class="body-large max-w-2xl mx-auto mb-8 px-4"
    >
      {{ 'projects.developer.description' | translate }}
    </p>

    <!-- Action Buttons -->
    <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
      <button
        class="btn-gradient w-full sm:w-auto h-12 sm:h-14 px-8 sm:px-10 text-sm sm:text-base group/btn"
      >
        <span>{{ 'projects.developer.joinButton' | translate }}</span>
        <i
          class="fa-solid fa-arrow-right text-sm sm:text-base group-hover/btn:translate-x-1 transition-transform"
          aria-hidden="true"
        ></i>
      </button>
      <button
        class="btn-outline w-full sm:w-auto h-12 sm:h-14 px-8 sm:px-10 text-sm sm:text-base"
      >
        {{ 'projects.developer.learnMoreButton' | translate }}
      </button>
    </div>
  </div>
</div>
